<div class="item-body" [ngClass]="breakPageClass">
    <!-- gsItem.type is grid, fix bug TAM-29295 -->
    <div class="header h3-regular" *ngIf="showHeader && !isGridTile()">
        {{gsItem.name}}
    </div>
    <!--
        For grid tiles, the grid-tile component still needs to be created even there's no data, as the excel export function is implemented by it.
        And the excel files without any data still need to be exported.

        Elaboration for ngIf and ngStyle conditions:
        1. *ngIf="!showNoData || isGridTile()" --- for non-grid tiles, keep the old rule, no-data-no-tile-component; for all grid tiles, grid-tile-component-create-all-the-time.
        2. [ngStyle]="{'visibility': showNoData && isGridTile() ? 'collapse' : 'visible'}" --- for non-grid tiles, the visibility is always visible, while for grid tiles those without any data would be collapsed, and the rest is still visible.
    -->
    <div class="body" *ngIf="!showNoData || isGridTile()"
        [ngStyle]="{'visibility': showNoData && isGridTile() ? 'collapse' : 'visible'}">
        <ng-template tamDashboardTileContainer></ng-template>
    </div>
    <div class="body" *ngIf="showNoData">
        <div class="no-data-box" [ngStyle]="getStyle()">
            There is no data available.
        </div>
    </div>
</div>
